import { Link } from "react-router-dom";
import "./NavbarMenu.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faGear,
  faPlus,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import imageUser from "../../assets/images/user/userImage.png";

import { useEffect, useState } from "react";
import SidbarMenu from "Components/Sidbar/SidbarMenu";
import NotificationSideBar from "Components/Notification/NotificationSideBar";

import LanguageSwitcher from "Components/Languages/LanguageSwitcher";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axios";
const NavbarMenu = () => {
  const [openButtons, setopenButtons] = useState(false);
  const [data, setData] = useState([]);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    axiosInstance
      .get("/profile", {
        headers: {
          "Accept-Language": i18n.language,
        },
      })
      .then((res) => {
        setData(res.data.data);
      }).catch((err) => { });
  }, []);
  const closeToggleTab = () => {
    setopenButtons(false);
  };

  // TOGGLE BAR SIDEBAR
  const [isOpen, setIsOpen] = useState(false);

  // OPEN SIDEBAR
  const toggleSidebar = () => {
    setIsOpen(true);
  };
  // CLOSE SIDEBAR
  const closeToggleSidebar = () => {
    setIsOpen(false);
  };

  // NOTIFICATION SIDEBAR
  const [showSidebar, setShowSidebar] = useState(false);
  const toggleSidebar1 = () => {
    setShowSidebar(true);
  };
  const closeNot = () => {
    setShowSidebar(false);
  };

  return (
    <>
      <NotificationSideBar showSidebar={showSidebar} closeNot={closeNot} />
      <div className="navbar-top">
        <SidbarMenu isOpen={isOpen} closeToggleSidebar={closeToggleSidebar} />
        <nav className="navbar navbar-expand-lg bg-white">
          <div className="container-fluid">
            <div className="info-user">
              <h2 className="title-name">
                {t("welcomeBack")} {data?.name}
              </h2>
              <p className="text">{t("welcomeBackMessage")}</p>
            </div>


          </div>
        </nav>
      </div>
    </>
  );
};

export default NavbarMenu;
